import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Card, MessagePlugin } from 'tdesign-react';
import { SendIcon } from 'tdesign-icons-react';
import { uniqueId } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { sendMessage } from '@/services/messageSARService';
import BuriedWrapper from '@/components/BuriedWrapper';
import { doBuried } from '@/services/buriedService';
import Item from './Item';

function Send({ currentTopic, submitting }) {
  const [inputMsg, setInputMsg] = useState('');
  const [messages, setMessages] = useState([
    { txt: '请在下方输入框中，输入要发送的消息', key: uniqueId() },
  ]);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const clusterName = searchParams.get('name');

  const doSend = async () => {
    if (inputMsg) {
      setLoading(true);
      try {
        await sendMessage({ clusterName, topic: currentTopic.fullTopicName, message: inputMsg });
        setMessages((currentMsg) => [
          ...currentMsg,
          { txt: `已发送消息：${inputMsg}`, key: uniqueId() },
        ]);
        setInputMsg('');
      } catch (error) {
        MessagePlugin.warning('发送失败');
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    doBuried({ eventId: 'MESSAGE_SEND_RECEIVE_PRODUCER_SEND' });
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      doSend();
    }
  };

  return (
    <Root shadow>
      <Title>
        <Icon src={require('../images/imac.png')} />
        生产者
      </Title>
      <Body className='narrow-scrollbar'>
        {messages.map((message) => (
          <Item key={message.key}>{message.txt}</Item>
        ))}
      </Body>
      <Footer>
        <BuriedWrapper eventId='MESSAGE_SEND_RECEIVE_PRODUCER_INPUT_FOCUS' triggerEvent='onFocus'>
          <Input
            value={inputMsg}
            onChange={(e) => setInputMsg(e.target.value)}
            onKeyUp={onKeyUp}
            autoFocus
            placeholder='请输入要发送的消息，按回车（或右侧发送按钮）发送'
          />
        </BuriedWrapper>
        <Button
          loading={submitting || loading}
          icon={<SendIcon />}
          shape='circle'
          size='large'
          onClick={doSend}
        />
      </Footer>
    </Root>
  );
}

export default connect((state) => ({
  currentTopic: state.messageSAR.currentTopic,
  submitting: state.messageSAR.submitting,
}))(Send);

const Root = styled(Card)`
  flex: 1;
  box-sizing: border-box;
  display: flex;
  border-radius: 16px;
  border: none;
  flex-direction: column;
  .t-card__body {
    display: flex;
    flex-direction: column;
    padding: 0;
    flex: 1;
  }
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: rgb(43, 43, 43);
  padding: 14px 20px;
  color: #bfff16;
  line-height: 18px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  padding: 22px 20px;
  display: flex;
`;

const Footer = styled.div`
  border-top: 1px solid rgb(231, 231, 231);
  height: 68px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  .t-button .t-icon {
    transform: rotate(-90deg);
  }
`;

const Input = styled.input`
  flex: 1;
  height: 35px;
  margin-right: 20px;
  border: none;
  font-size: 16px;
  outline: none;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;
